export default "/fonts/vendor/@mdi/materialdesignicons-webfont.eot?b04f03f08b5445700a300d848ef698b3";